import React from 'react'

// import icons
import { BsFacebook, BsGithub, BsLinkedin, BsTwitter } from 'react-icons/bs';
import { AiFillMediumCircle } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import useFetch from '../hooks/useFetch';
import Loading from '../components/Loading';

const ShowPage = () => {
  const pathHash = window.location.pathname.split('/');
  const url = pathHash[1] === 'Projects' ? `/projects/${pathHash[2]}` : `/articles/${pathHash[2]}`;
  const [data, loading] = useFetch(url);

  return (
    <div className='show-container'>
      {loading ? <Loading /> :
        <>
          <section className='hero-image' style={{ backgroundImage: `linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url(${data.image_url})`, height: "60vh" }}></section>
          <div className='show-descriptions'>
            <h2 className='text-center'>{data.title}</h2>
            <p className='text-start' dangerouslySetInnerHTML={{__html: data.body}} ></p>
            <div className="show-page-link-container">
              <ul className='d-flex'>
                <li><Link to=""  className='show-page-link'><BsFacebook className='fs-3' /></Link></li>
                <li><Link to=""  className='show-page-link'><BsGithub className='fs-3' /></Link></li>
                <li><Link to=""  className='show-page-link'><AiFillMediumCircle className='fs-3' /></Link></li>
                <li><Link to=""  className='show-page-link'><BsLinkedin className='fs-3' /></Link></li>
                <li><Link to=""  className='show-page-link'><BsTwitter className='fs-3' /></Link></li>
              </ul>
            </div>
            <p>{data.type}</p>
          </div>
        </>
      }
    </div>
  )
}

export default ShowPage